import { useField } from "formik";
import { Checkbox } from "@/components/ui/checkbox";
import { Label } from "@/components/ui/label";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";
import { FIELD_LABEL } from "@/features/clients/components/profile-form-shared";

/** Formik-bound shadcn Select for enum fields in the sub-record dialogs. */
export function SelectField({
  name,
  label,
  options,
  placeholder = "Select…",
}: {
  name: string;
  label: string;
  options: { value: string; label: string }[];
  placeholder?: string;
}) {
  const [field, meta, helpers] = useField<string>(name);
  const hasError = meta.touched && !!meta.error;
  return (
    <div className="grid gap-2">
      <Label className={FIELD_LABEL}>{label}</Label>
      <Select value={field.value || undefined} onValueChange={(v) => helpers.setValue(v)}>
        <SelectTrigger className="w-full" aria-invalid={hasError}>
          <SelectValue placeholder={placeholder} />
        </SelectTrigger>
        <SelectContent>
          {options.map((o) => (
            <SelectItem key={o.value} value={o.value}>
              {o.label}
            </SelectItem>
          ))}
        </SelectContent>
      </Select>
      {hasError && <p className="text-destructive text-sm">{meta.error}</p>}
    </div>
  );
}

/** Formik-bound checkbox with a trailing label. */
export function CheckboxField({ name, label }: { name: string; label: string }) {
  const [field, meta, helpers] = useField<boolean>(name);
  const hasError = meta.touched && !!meta.error;
  return (
    <div className="grid gap-1">
      <div className="flex items-center gap-2">
        <Checkbox
          id={name}
          checked={field.value}
          aria-invalid={hasError}
          onCheckedChange={(v) => helpers.setValue(v === true)}
        />
        <Label htmlFor={name} className="text-muted-foreground font-normal">
          {label}
        </Label>
      </div>
      {hasError && <p className="text-destructive text-sm">{meta.error}</p>}
    </div>
  );
}
